import { useState, useEffect } from "react";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogFooter,
  AlertDialogTitle, AlertDialogDescription, AlertDialogAction, AlertDialogCancel,
} from "@/components/ui/alert-dialog";

// Promise-based, in-app replacement for window.confirm() so we never show the
// browser's native "<url> says" popup. Usage: if (!(await confirm({...}))) return;
let _open = null;

export function confirm(opts = {}) {
  return new Promise((resolve) => {
    if (_open) _open(typeof opts === "string" ? { description: opts } : opts, resolve);
    else resolve(true);
  });
}

export function ConfirmHost() {
  const [state, setState] = useState(null);

  useEffect(() => {
    _open = (opts, resolve) => setState({ opts, resolve });
    return () => { _open = null; };
  }, []);

  const settle = (val) => {
    if (state) state.resolve(val);
    setState(null);
  };

  const o = state?.opts || {};
  return (
    <AlertDialog open={!!state} onOpenChange={(open) => { if (!open) settle(false); }}>
      <AlertDialogContent data-testid="confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>{o.title || "Are you sure?"}</AlertDialogTitle>
          {o.description && <AlertDialogDescription className="whitespace-pre-wrap">{o.description}</AlertDialogDescription>}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="confirm-cancel" onClick={() => settle(false)}>{o.cancelText || "Cancel"}</AlertDialogCancel>
          <AlertDialogAction
            data-testid="confirm-ok"
            onClick={() => settle(true)}
            className={o.destructive ? "bg-red-600 hover:bg-red-700 focus:ring-red-600" : "bg-brand hover:bg-brand-dark"}
          >
            {o.confirmText || "Confirm"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
